module.exports = __webpack_public_path__ + "static/media/achievement-dance-monkey.59041e7e.svg";